import { stepIndex, stepProgressText, type CheckoutStep, type StepId } from "../../state/checkout-steps";

/**
 * Where the guest is in the full-page checkout. Wider screens: one labelled
 * segment per step ("Your details · Riders · Booking details · Review &
 * pay"), done / current / to come. A phone: one line, "Step 2 of 4 ·
 * Riders". The step heading below it takes focus on every change and the
 * page's live region says the same line, so this list is not a live region
 * itself.
 */
export function CheckoutProgress({
  steps,
  current,
  compact,
  numbered = false,
}: {
  steps: readonly CheckoutStep[];
  current: StepId;
  compact: boolean;
  numbered?: boolean;
}) {
  if (compact) {
    return (
      <p className="vt-checkout-progress vt-checkout-progress-compact" data-step={current}>
        {stepProgressText(steps, current)}
      </p>
    );
  }
  const at = stepIndex(steps, current);
  return (
    <ol className="vt-checkout-progress" aria-label="Checkout steps" data-step={current} data-numbered={numbered ? "true" : undefined}>
      {steps.map((step, i) => {
        const state = i < at ? "done" : i === at ? "current" : "todo";
        return (
          <li
            key={step.id}
            className="vt-checkout-progress-step"
            data-state={state}
            aria-current={state === "current" ? "step" : undefined}
          >
            {numbered ? (
              <span className="vt-checkout-progress-number" aria-hidden="true">{i + 1}</span>
            ) : (
              <span className="vt-checkout-progress-bar" aria-hidden="true" />
            )}
            <span className="vt-checkout-progress-label">
              <span className="vt-sr-only">
                {state === "done" ? "Done: " : state === "current" ? "Now: " : "Next: "}
              </span>
              {step.label}
            </span>
          </li>
        );
      })}
    </ol>
  );
}
